<template>
	<b-container fluid>
		<page-title><h2 v-if="item"><router-link :to="{ name: 'InvoiceTaxTypeList' }" class="nav-link">Stawki podatku VAT</router-link>/Edycja</h2></page-title>

		<div class="col page-element">
			<div v-if="created" class="alert alert-success" role="status">{{ created['@id'] }} created.</div>
			<div v-if="updated" class="alert alert-success" role="status">{{ updated['@id'] }} updated.</div>
			<alert-loading v-if="retrieveLoading || updateLoading"></alert-loading>
			<div v-if="retrieveError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ retrieveError }}</div>
			<div v-if="updateError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ updateError }}</div>

			<InvoiceTaxTypeForm v-if="item && !retrieveLoading && !updateLoading" :handle-submit="update" :values="item" :errors="violations" :initialValues="retrieved"></InvoiceTaxTypeForm>
		</div>
	</b-container>
</template>

<script>
  import InvoiceTaxTypeForm from './Form.vue';
  import { mapGetters } from 'vuex';

  export default {
    created () {
      this.$store.dispatch('invoicetaxtype/update/retrieve', decodeURIComponent(this.$route.params.id));
    },
    components: {
      InvoiceTaxTypeForm
    },
    computed: {
      ...mapGetters({
        retrieveError: 'invoicetaxtype/update/retrieveError',
        retrieveLoading: 'invoicetaxtype/update/retrieveLoading',
        updateError: 'invoicetaxtype/update/updateError',
        updateLoading: 'invoicetaxtype/update/updateLoading',
        created: 'invoicetaxtype/create/created',
        retrieved: 'invoicetaxtype/update/retrieved',
        updated: 'invoicetaxtype/update/updated',
        violations: 'invoicetaxtype/update/violations'
      })
    },
    data: function() {
      return {
        item: {}
      }
    },
    methods: {
      update (values) {
        this.$store.dispatch('invoicetaxtype/update/update', {item: this.retrieved, values: values });
      },
      reset () {
        this.$store.dispatch('invoicetaxtype/update/reset');
        this.$store.dispatch('invoicetaxtype/create/reset');
      }
    },
    beforeDestroy() {
      this.reset();
    }
  }
</script>



// WEBPACK FOOTER //
// Update.vue?794cad66